import { render, staticRenderFns } from "./main-navbar-switch-tenant.vue?vue&type=template&id=3ab546f2&"
import script from "./main-navbar-switch-tenant.vue?vue&type=script&lang=js&"
export * from "./main-navbar-switch-tenant.vue?vue&type=script&lang=js&"
import style0 from "./main-navbar-switch-tenant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports